import isEqual from 'lodash/fp/isEqual';

import { usePrevious } from './UsePrevious';

export const useValueChanged = <V,>(value: V): boolean => {
  const previousValue = usePrevious(value);
  return !isEqual(previousValue, value);
};
